import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  path?: string;
}

interface Props {
  items: Crumb[];
  tone?: 'light' | 'dark';
}

export default function Breadcrumb({ items, tone = 'light' }: Props) {
  const isLight = tone === 'light';
  const base = isLight ? 'text-foreground-500' : 'text-background-400';
  const link = isLight ? 'hover:text-primary-600' : 'hover:text-accent-300';
  const current = isLight ? 'text-foreground-800' : 'text-background-100';

  return (
    <nav aria-label="面包屑导航" className={`text-xs md:text-sm ${base}`}>
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, idx) => {
          const last = idx === items.length - 1;
          return (
            <li key={`${item.label}-${idx}`} className="flex items-center gap-2">
              {item.path && !last ? (
                <Link to={item.path} className={`${link} transition-colors`}>
                  {item.label}
                </Link>
              ) : (
                <span className={last ? current : ''} aria-current={last ? 'page' : undefined}>
                  {item.label}
                </span>
              )}
              {!last && <i className="ri-arrow-right-s-line opacity-60"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}